import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Tooltip from "@mui/material/Tooltip";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            Our Web Development Services
          </h3>
          <p>
          We have vast experience in Next.js, React, Webflow, Wordpress, Shopify, Magento, Squarespace, Sitecore, Drupal and .NET. 
          </p>
          <p>
          For the above platforms we offer the following services:
          </p>
          <ul>
            <li>Complete design for up to moderately sized websites</li>
            <li>Form & 3rd party database integration & tagging (eg Salesforce)</li>
            <li>Landing page design and creation</li>
            <li>Web design strategy and UX</li>
            <li>SEO Strategy</li>
          </ul>
        </GridItem>
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
          Our Unique Selling Propositions
          </h3>
          <p>
          We combine data smarts, tracking and SEO knowledge - with design, to give a <strong>data conscious design</strong>. One that uses data to inform its design but is also set up properly to collect the data you need from conversions, form submissions, website usage and attribution tools.
          </p>
          <p>
          We have a unique blend of technical (data, seo, coding and design) experience and client/business experience give you a very considered and practical viewpoint on what you need to do to improve your website.
          </p>
          <p>
          We dont subcontract everything out to an offshore agency and make a margin off that. Our local staff are deeply involved with every project.
          </p>
          
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
          Why do we do web design?
          </h3>
          <p>
          It is often (although not always) an extension of our data services. Where key projects identify changes that need to be made to the site - we can implement them - not just point them out and add them to a list of potential things for someone else to do.
          </p>
          <p>
          While we understand the ultimate primacy of design appeal and user experience, there is often a disconnect where designs veer off away from the main purpose of the site, for example lead capture or ecommerce. We often work with other development teams in projects and ensure the data, seo and tracking site of things is up to speed - but often it is more practical to combine it all under the one roof with us.
          </p>
          <p>
          Plus, we're just simply good at it. 😀
          </p>
          
          
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Examples of our work: Bizcap Webflow & Wordpress</h3>
          <p>
            We have redeveloped two versions of the Bizcap website - originally in Wordpress and recently redeveloping in Webflow. Not only that we have extended the original AU website to have seperate NZ and now UK versions too! All of these have UX, SEO, tracking and 3rd party CRM integration at their heart.
            <br />
            <br />
          </p>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <a href ="https://www.bizcap.com.au" target="_blank">
              <img
                src="/img/sections/services/web-development-services/bizcap-au-site.png"
                alt="..."
                className={imgClasses}
              />
              </a>
              <p>
                <br />
              </p>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
            <a href ="https://www.bizcap.co.uk" target="_blank">
              <img
                src="/img/sections/services/web-development-services/bizcap-uk-site.png"
                alt="..."
                className={imgClasses}
              />
              </a>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/web-development-services/2-small-resize.webp"
                alt="..."
                className={imgClasses}
              />
            </GridItem>
          </GridContainer>
          <div style={{ textAlign: "center" }}>
            <p>
              <i>Left: Bizcap AU (Webflow - 2024), Centre: Bizcap UK (Webflow - 2024), Right: Bizcap AU (Wordpress - 2019)</i>
            </p>
          </div>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>

          <p>
            For more on the above redesign work with Bizcap -  <a href="/our-work/bizcap">check out our case study here</a>.
            <br />
            <br />
            </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              <strong>Quality:</strong> We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
            <strong>Communication:</strong> We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
            <strong>Innovative:</strong> We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>
          <p>
            <br /> For more details get in touch with us through the contact
            form below below!
          </p>
          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
